import '../styles/menu.scss';
import Companies from '../assets/companies';
import Users from '../assets/users';
import Docs from '../assets/docs';
import Dashboard from '../assets/dashboard';
import { useLocation } from 'react-router-dom';

const Menu = (selected)=>{
    const location = useLocation();

    return (
      <div className='menu' >
        <a href="/dashboard" className={location.pathname === '/dashboard' ? '-active' : ''}>
          <Dashboard /> Dashboard
        </a>
        <a href="/admin" className={location.pathname === '/admin' ? '-active' : ''}>
          <Companies /> Patrones
        </a>
        <a href="/admin/collaborators" className={location.pathname === '/admin/collaborators' ? '-active' : ''}>
          <Users /> Colaboradores
        </a>
        <a href="/admin/documents" className={location.pathname === '/admin/documents' ? '-active' : ''}>
          <Docs /> Documentos
        </a>
      </div>
    );
}

export default Menu;